import { queryOptions, useMutation, useQuery, useQueryClient, useSuspenseQuery } from "@tanstack/react-query"
import { addParentToStudent, getStudentParentPortalAccounts, getStudentParents, removeParentFromStudent } from "./api"
import { parentQueryOptions } from "@features/parent-page/queries"

export const studentParentsQueryOptions = (studentNo: string) =>
    queryOptions({
        queryKey: ['studentParents', studentNo],
        queryFn: () => getStudentParents(studentNo),
    })

export function useStudentParents(studentNo: string) {
    return useQuery(studentParentsQueryOptions(studentNo))
}

export function useStudentParentsSuspense(studentNo: string) {
    return useSuspenseQuery(studentParentsQueryOptions(studentNo))
}

export const studentParentPortalAccountsQueryOptions = (studentNo: string) =>
    queryOptions({
        queryKey: ['studentParentPortalAccounts', studentNo],
        queryFn: () => getStudentParentPortalAccounts(studentNo),
    })

export function useStudentParentPortalAccounts(studentNo: string) {
    return useQuery(studentParentPortalAccountsQueryOptions(studentNo))
}

export function useStudentParentPortalAccountsSuspense(studentNo: string) {
    return useSuspenseQuery(studentParentPortalAccountsQueryOptions(studentNo))
}

export function useAddParentToStudentMutation(parentId: string) {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: async (studentNo: string) => addParentToStudent(parentId, studentNo),
        onSuccess: (data, variables) => {
            queryClient.invalidateQueries(parentQueryOptions(parentId))
            queryClient.invalidateQueries({queryKey: studentParentPortalAccountsQueryOptions(variables).queryKey})
        },
    })
}

export function useRemoveParentFromStudentMutation(parentId: string) {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: async (studentNo: string) => removeParentFromStudent(parentId, studentNo),
        onSuccess: (data, variables) => {
            queryClient.invalidateQueries(parentQueryOptions(parentId))
            queryClient.invalidateQueries({queryKey: studentParentPortalAccountsQueryOptions(variables).queryKey})
        },
    })
}
